
import {JackpotToastType, SuggestedGameClickedCloseReason} from "../../../../components/jackpot-toast/jackpot-toast.component";
import {IServiceFactory} from "../../../service-factory.interface";
import {ToastCloseReason} from "../../../toaster/toaster.service.interface";

export function onGameClickedAnalytics(
    services: Pick<IServiceFactory, 'analytics'>,
    toastId: string | number,
    toastType: JackpotToastType,
    amount: number,
    gameType: number,
    gamePosition: number
) {
    services.analytics.sendOrbitUserFlowEvent(
        "New_Jackpot_Toast", // category
        "jackpot_toaster_game_click", // action
        toastType, // label
        {amountValue: amount, gameType, gamePosition, toastId} // value
    );
}

export function onShowAnalytics(
    services: Pick<IServiceFactory, 'analytics'>,
    toastId: string | number,
    toastType: JackpotToastType,
    amount: number,
) {
    services.analytics.sendOrbitUserFlowEvent(
        "New_Jackpot_Toast", // category
        "jackpot_toaster_displayed", // action
        toastType, // label
        {amountValue: amount, toastId} // value
    );
}

export function onCloseAnalytics(
    services: Pick<IServiceFactory, 'analytics'>,
    toastId: string | number,
    toastType: JackpotToastType,
    amount: number,
    closeReason: string
) {
    if (closeReason === SuggestedGameClickedCloseReason) {
        return;
    }
    services.analytics.sendOrbitUserFlowEvent(
        "New_Jackpot_Toast", // category
        "jackpot_toaster_closed", // action
        toastType, // label
        {amountValue: amount, closedByX: closeReason === ToastCloseReason.CloseButton, toastId} // value
    );
}